module.exports = __webpack_public_path__ + "static/media/mns-logo.13723cbe.png";